import Phaser from 'phaser';

const BG_OUTER = 0x0f172a;
const BG_INNER = 0x1e3a8a;
const BLADE_COLOR = 0xe5e7eb;
const BLADE_EDGE = 0x64748b;
const GLOW = 0xfbbf24;
const STROKE = 0x0a0f1f;

export function drawAdamantium(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  g.fillStyle(GLOW, 0.35);
  g.fillCircle(0, r * 0.4, r * 0.45);

  const bladeLen = r * 1.1;
  const bladeW = Math.max(3, r * 0.14);
  const spacing = r * 0.32;

  for (let i = -1; i <= 1; i++) {
    const cx = spacing * i;
    const p0x = cx;
    const p0y = r * 0.4;
    const p1x = cx;
    const p1y = p0y - bladeLen;
    drawBlade(g, p0x, p0y, p1x, p1y, bladeW, BLADE_COLOR, BLADE_EDGE, Math.max(1, Math.floor(bladeW * 0.3)));
  }

  g.fillStyle(BLADE_EDGE, 1);
  g.lineStyle(Math.max(1, Math.floor(stroke * 0.7)), STROKE, 1);
  g.fillRoundedRect(-r * 0.55, r * 0.35, r * 1.1, r * 0.2, 3);
  g.strokeRoundedRect(-r * 0.55, r * 0.35, r * 1.1, r * 0.2, 3);
}

function drawBlade(
  g: Phaser.GameObjects.Graphics,
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  width: number,
  fill: number,
  stroke: number,
  strokeW: number,
) {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const len = Math.hypot(dx, dy);
  if (len === 0) return;
  const nx = -dy / len;
  const ny = dx / len;
  const hx = (nx * width) / 2;
  const hy = (ny * width) / 2;
  const tipX = x2;
  const tipY = y2;
  const p0 = { x: x1 + hx, y: y1 + hy };
  const p3 = { x: x1 - hx, y: y1 - hy };
  g.fillStyle(fill, 1);
  g.lineStyle(strokeW, stroke, 1);
  g.beginPath();
  g.moveTo(p0.x, p0.y);
  g.lineTo(tipX, tipY);
  g.lineTo(p3.x, p3.y);
  g.closePath();
  g.fillPath();
  g.strokePath();
}
